<mat-nav-list class="main-nav-list">
  <a mat-list-item class="toggle-menu" (click)="toggleSidebar()">
    <!-- Initial state icon -->
    <mat-icon
      *ngIf="(sidebarPinned$ | async) === false"
      matListItemIcon
      class="menuTrigger menuTrigger--default"
      svgIcon="menu"
      matTooltip="Navigation"
      i18n-matTooltip="@@shared.sidebar.attrNavigation"
    ></mat-icon>
    <!-- Show on menu hover -->
    <mat-icon
      *ngIf="(sidebarPinned$ | async) === false"
      matListItemIcon
      class="menuTrigger menuTrigger--expand"
      svgIcon="chevron-double-right"
      matTooltip="Expand"
      i18n-matTooltip="@@shared.sidebar.attrExpand"
    ></mat-icon>
    <!-- Show when menu is pinned -->
    <mat-icon
      *ngIf="sidebarPinned$ | async"
      matListItemIcon
      class="menuTrigger menuTrigger--collapse"
      [svgIcon]="isHandset ? 'close' : 'chevron-double-left'"
      matTooltip="Collapse"
      i18n-matTooltip="@@shared.sidebar.attrCollapse"
    ></mat-icon>
    <div *ngIf="!isHandset" matListItemTitle i18n="@@shared.sidebar.lblNavigation">Navigation</div>
    <div *ngIf="isHandset" class="d-flex align-items-center">
      <svg
        class="mobileLogoImg"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 524 93"
        xml:space="preserve"
      >
        <g>
          <path fill="#FFFFFF" d="M340.5,0h4.3v93.4h-4.3V0z" />
          <path fill="#FFFFFF" d="M0,17.3h8v51.1h19.2v8H0V17.3z" />
          <path
            fill="#FFFFFF"
            d="M102.6,17.4h8.1v36.3c0,5.4,1.3,9.5,3.9,12.5c2.6,2.9,6.2,4.4,11,4.4c4.7,0,8.3-1.3,11-4c2.7-2.7,4-6.5,3.9-11.4V17.4h8.1
              v37.2c0,7.2-2.1,13-6.2,17.3c-4.1,4.3-9.6,6.5-16.5,6.5c-7,0-12.6-2.2-16.9-6.6s-6.3-10.9-6.3-19.4L102.6,17.4z"
          />
          <path fill="#FFFFFF" d="M161.9,17.3H198v8.1h-14.1v51h-8v-51h-14V17.3z" />
          <path fill="#FFFFFF" d="M211.8,17.3h32.8v8.1h-24.8v14.8h24.8v8h-24.8v20.3h24.8v8h-32.8V17.3z" />
          <path
            fill="#FFFFFF"
            d="M307,19.4v9.1c-6.4-3.1-12.2-4.7-17.6-4.7c-6.4-0.2-12.7,2.2-17.4,6.6c-4.6,4.2-7.2,10.1-7.1,16.3
              c-0.1,6.3,2.5,12.3,7.2,16.5c4.8,4.4,10.8,6.6,18.1,6.6c5.3,0,10.8-1.7,16.7-5V74c-5.4,2.8-11.3,4.3-17.4,4.3
              c-8.8,0.2-17.2-3.2-23.5-9.3c-6.3-5.7-9.8-13.9-9.7-22.4c-0.1-8.4,3.4-16.4,9.6-22c6.2-6,14.5-9.3,23.1-9.2
              C295.3,15.5,301.3,16.9,307,19.4z"
          />
          <polygon
            fill="#FFFFFF"
            points="65.9,15 61.7,24.3 65.9,33.5 65.9,33.5 75.4,54.6 48.1,54.6 45.1,61.3 53.4,61.3 78.5,61.3 85.3,76.4 93.8,76.4
                  "
          />
          <path
            fill="#FFFFFF"
            d="M440.4,17.4h11.9c6.7,0,12.1,1.6,16.2,4.7c4,2.8,6.3,7.4,6.2,12.3c0,5.1-2.2,9.3-6.5,12.8c-4.3,3.4-10.9,5.1-19.8,5v24.3
              h-8L440.4,17.4z M448.4,24.5v20.7c6.1-0.1,10.5-0.9,13.5-2.6c2.9-1.6,4.6-4.7,4.4-8c0-2.8-1.2-5.4-3.3-7.1
              C460.7,25.5,455.9,24.5,448.4,24.5L448.4,24.5z"
          />
          <path
            fill="#FFFFFF"
            d="M488.2,17.4H501c6.4,0,11.6,1.6,15.6,4.8c3.8,2.9,6.1,7.4,6,12.2c0,3.9-1.3,7.6-3.9,10.5c-2.6,3-6.6,5.2-12.1,6.4
              l17.2,25.3h-9.3l-16.4-24.3h-1.8v24.3h-8.1V17.4z M496.3,24.6v20.6c11.9,0.2,17.8-3.2,17.8-10.4c0.1-2.2-0.6-4.4-2.1-6.1
              c-1.5-1.6-3.4-2.8-5.6-3.2C503.2,24.8,499.7,24.5,496.3,24.6z"
          />
          <path
            fill="#FFFFFF"
            d="M426.2,47c0-7.7-3-15-8.3-20.5c-5.5-6-14-9-25.3-9h-14.3v59.1h8.1V25.3h4.1c6,0,10.8,0.6,14.4,1.9c3.8,1.4,7,4,9.2,7.4
              c2.5,3.6,3.9,7.9,3.9,12.3c0,3.5-0.8,6.9-2.4,10c-1.5,2.9-3.8,5.4-6.5,7.3c-2.6,1.8-5.5,3-8.6,3.6c-2,0.3-3.9,0.5-5.9,0.6v8.1
              c10.1-0.3,17.8-3.3,23.2-8.9C423.3,61.6,426.2,54.7,426.2,47z"
          />
        </g>
      </svg>
    </div>
  </a>

  <ng-container *ngIf="isHandset">
    <a
      *ngLet="{baseAccount: baseAccount$ | async, selectedClient: selectedClient$ | async} as observables"
      class="mt-2"
      mat-list-item
      data-testId="sidebar-open-select-client"
      [disabled]="!isAppOnline"
      (click)="selectClient()"
    >
      <div class="d-flex justify-content-between">
        <div class="d-flex mdc-list-item--with-leading-icon align-items-center text-truncate">
          <mat-icon svgIcon="domain" class="icon--large" matListItemIcon></mat-icon>
          <div data-testid="selectedClient" class="text-truncate">{{observables.selectedClient?.name}}</div>
        </div>
        <div class="d-flex align-items-center mx-3" i18n="@@shared.sidebar.lblSelectClient">
          Select Client
          <mat-icon class="ml-2 icon--large" svgIcon="arrow-right"></mat-icon>
        </div>
      </div>
    </a>

    <mat-divider class="my-2"></mat-divider>
  </ng-container>

  <ng-container *ngFor="let item of (menuItems$ | async)">
    <a
      *ngIf="item.hasAccess"
      [ngClass]="{ 'active': item.isLinkActive}"
      mat-list-item
      [attr.data-testid]="'sidebar-' + item.dataTestId"
      (click)="navigateToItem(item)"
    >
      <mat-icon
        [svgIcon]="item.icon"
        matListItemIcon
        [matTooltip]="item.label"
        [matTooltipDisabled]="sidebarPinned$ | async"
      ></mat-icon>
      <div matListItemTitle>{{item.label}}</div>
    </a>
  </ng-container>

  <ng-container *ngIf="isHandset">
    <mat-divider class="my-2"></mat-divider>

    <a mat-list-item data-testId="sidebar-open-user-preferences" (click)="openUserPreferencesDialog()">
      <mat-icon svgIcon="account-cog" matListItemIcon></mat-icon>
      <div matListItemTitle i18n="@@shared.sidebar.lblUserPreferences">User Preferences</div>
    </a>

    <ng-container *ngTemplateOutlet="supportLauncher"></ng-container>

    <div class="mt-auto">
      <mat-divider></mat-divider>

      <div class="d-flex justify-content-between align-items-center my-2">
        <div
          *ngLet="{baseAccount: baseAccount$ | async, selectedClient: selectedClient$ | async} as observables"
          class="ml-3"
        >
          <app-account-signature
            class="accountSignatureSidebar"
            [account]="observables.baseAccount"
            [useOnlyAvatar]="false"
            [shouldDisplayTooltip]="false"
            [shouldDisplayEmail]="true"
            [avatarSize]="'large'"
          ></app-account-signature>
        </div>
        <div class="mr-3">
          <a
            matTooltip="Signing out is not possible in offline mode"
            [matTooltipDisabled]="isAppOnline"
            i18n-matTooltip="@@shared.sidebar.attrSignOutOffline"
            [disabled]="!isAppOnline"
            class="ml-auto"
            mat-list-item
            (click)="signOut()"
          >
            <mat-icon svgIcon="logout" class="mr-2" matListItemIcon></mat-icon>
            <div matListItemTitle i18n="@@shared.sidebar.lblSignOut">Sign out</div>
          </a>
        </div>
      </div>
    </div>
  </ng-container>

  <div *ngIf="!isHandset" class="mt-auto">
    <ng-container *ngTemplateOutlet="supportLauncher"></ng-container>

    <a mat-list-item (click)="toggleFullScreenMode()">
      <mat-icon
        data-testId="toggle-full-screen"
        svgIcon="open-in-full"
        matListItemIcon
        i18n-matTooltip="@@shared.sidebar.attrFullScreen"
        matTooltip="Full-Screen"
        [matTooltipDisabled]="sidebarPinned$ | async"
        class="qa-sidebar-full-screen"
      ></mat-icon>
      <div matListItemTitle i18n="@@shared.sidebar.lblFullScreen">Full-Screen</div>
    </a>
  </div>

  <!-- Support (Zendesk) custom launcher — shared by the desktop and handset
       blocks. Declared inside mat-nav-list so the templated list item resolves
       MatNavList via DI (interactive styling: pointer cursor, hover/focus).
       The tooltip is suppressed on handset (labels are always visible there) and
       when the desktop sidebar is pinned/expanded. -->
  <ng-template #supportLauncher>
    <a
      *ngIf="canShowSupport$ | async"
      mat-list-item
      data-testId="sidebar-support"
      [ngClass]="{ 'active': isSupportOpen$ | async }"
      (click)="toggleSupport()"
    >
      <mat-icon
        svgIcon="message-text"
        matListItemIcon
        [matBadge]="supportUnreadCount$ | async"
        [matBadgeHidden]="(supportHasUnread$ | async) === false"
        matBadgeColor="warn"
        matBadgeSize="small"
        matTooltip="Support"
        i18n-matTooltip="@@shared.sidebar.attrSupport"
        [matTooltipDisabled]="isHandset || (sidebarPinned$ | async)"
        class="sidebar-support"
      ></mat-icon>
      <div matListItemTitle i18n="@@shared.sidebar.lblSupport">Support</div>
    </a>
  </ng-template>
</mat-nav-list>
